export const FormatCurrency = (amount, currency = "XOF") => {
  if (typeof amount !== "number" || isNaN(amount)) return "—";

  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
  }).format(amount);
};
